// src/components/WhyUsSection/WhyUsSection.jsx

import React from 'react';
import './WhyUsSection.css';
import { FaBoxes, FaTools, FaTruck } from 'react-icons/fa';

// --- YENİ: Arka plan görsellerini import et ---
// Yolların kendi projenndeki assets klasörüne göre doğru olduğundan emin ol
import whyusProductsBg from '../../assets/whyus-products.jpg'; // Örnek yol
import whyusSupportBg from '../../assets/whyus-support.jpg';   // Örnek yol
import whyusDeliveryBg from '../../assets/whyus-delivery.jpg'; // Örnek yol

function WhyUsSection() {
  return (
    <section id="neden-sancak" className="whyus-container">
      <div className="whyus-wrapper">
        <h2 className="whyus-section-title">Neden Sancak?</h2>
        <p className="whyus-section-subtitle">
          Projelerinizi ve yaşam alanlarınızı dönüştürmek için buradayız.
        </p>
        
        <div className="whyus-grid">
          
          {/* Sütun 1: Geniş Yelpaze */}
          {/* --- DEĞİŞİKLİK BURADA: style ve data-background eklendi --- */}
          <div 
            className="whyus-card" 
            style={{ backgroundImage: `url(${whyusProductsBg})` }}
            data-background-type="products" // CSS için özel bir tanımlayıcı
          >
            <div className="whyus-card-overlay"></div> {/* Resmin üzerine gelecek opak katman */}
            <div className="whyus-card-content">
              <div className="whyus-icon-wrapper">
                <FaBoxes />
              </div>
              <h3 className="whyus-card-title">Geniş Ürün Yelpazesi</h3>
              <p className="whyus-card-description">
                Aradığınız tüm ankastre, hırdavat ve mobilya aksesuarları 
                çözümleri tek bir adreste.
              </p>
            </div>
          </div>
          
          {/* Sütun 2: Proje Desteği */}
          {/* --- DEĞİŞİKLİK BURADA: style ve data-background eklendi --- */}
          <div 
            className="whyus-card" 
            style={{ backgroundImage: `url(${whyusSupportBg})` }}
            data-background-type="support"
          >
            <div className="whyus-card-overlay"></div>
            <div className="whyus-card-content">
              <div className="whyus-icon-wrapper">
                <FaTools />
              </div>
              <h3 className="whyus-card-title">Uzman Proje Desteği</h3>
              <p className="whyus-card-description">
                Uzman ekibimizle mimari ve bireysel projelerinize 
                özel çözümler ve danışmanlık sunuyoruz.
              </p>
            </div>
          </div>
          
          {/* Sütun 3: Hızlı Tedarik */}
          {/* --- DEĞİŞİKLİK BURADA: style ve data-background eklendi --- */}
          <div 
            className="whyus-card" 
            style={{ backgroundImage: `url(${whyusDeliveryBg})` }}
            data-background-type="delivery"
          >
            <div className="whyus-card-overlay"></div>
            <div className="whyus-card-content">
              <div className="whyus-icon-wrapper">
                <FaTruck />
              </div>
              <h3 className="whyus-card-title">Güven ve Hızlı Tedarik</h3>
              <p className="whyus-card-description">
                Güçlü stok altyapımız ile ihtiyaç duyduğunuz ürünleri 
                en hızlı şekilde sizlere ulaştırıyoruz.
              </p>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}

export default WhyUsSection;